import { render, staticRenderFns } from "./CustomSelectedCurrents.vue?vue&type=template&id=37c8104d"
import script from "./CustomSelectedCurrents.vue?vue&type=script&lang=js"
export * from "./CustomSelectedCurrents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports